(function () {
  var MONTHS_RO = [
    'ianuarie',
    'februarie',
    'martie',
    'aprilie',
    'mai',
    'iunie',
    'iulie',
    'august',
    'septembrie',
    'octombrie',
    'noiembrie',
    'decembrie'
  ];

  function initializePilatesBooking() {
    var modal = document.querySelector('[data-pilates-booking-modal]');

    if (!modal || modal.dataset.initialized === 'true') return;

    var dataElement = modal.querySelector('[data-pilates-booking-data]');
    if (!dataElement) return;

    var bookingData;

    try {
      bookingData = JSON.parse(dataElement.textContent);
    } catch (error) {
      console.error('Pilates booking data invalid:', error);
      return;
    }

    modal.dataset.initialized = 'true';

    var titleElement = modal.querySelector('[data-pilates-booking-title]');
    var instructionElement = modal.querySelector('[data-pilates-booking-instruction]');
    var monthElement = modal.querySelector('[data-pilates-booking-month]');
    var daysElement = modal.querySelector('[data-pilates-booking-days]');
    var emptyElement = modal.querySelector('[data-pilates-booking-empty]');
    var errorElement = modal.querySelector('[data-pilates-booking-error]');
    var counterElement = modal.querySelector('[data-pilates-booking-counter]');
    var remainingElement = modal.querySelector('[data-pilates-booking-remaining]');
    var selectionElement = modal.querySelector('[data-pilates-booking-selection]');
    var continueButton = modal.querySelector('[data-pilates-booking-continue]');
    var calendarArea = modal.querySelector('[data-pilates-calendar-area]');
    var summaryElement = modal.querySelector('[data-pilates-booking-summary]');
    var courseArea = modal.querySelector('[data-pilates-course]');
    var courseErrorElement = modal.querySelector('[data-pilates-course-error]');
    var courseContinueButton = modal.querySelector('[data-pilates-course-continue]');
    var courseFields = {
      title: modal.querySelector('[data-pilates-course-title]'),
      participants: modal.querySelector('[data-pilates-course-participants]'),
      duration: modal.querySelector('[data-pilates-course-duration]'),
      start: modal.querySelector('[data-pilates-course-start]'),
      modulesCount: modal.querySelector('[data-pilates-course-modules-count]'),
      module1: modal.querySelector('[data-pilates-course-module-1]'),
      module2: modal.querySelector('[data-pilates-course-module-2]'),
      module3: modal.querySelector('[data-pilates-course-module-3]'),
      module4: modal.querySelector('[data-pilates-course-module-4]'),
      certification: modal.querySelector('[data-pilates-course-certification]'),
      recognition: modal.querySelector('[data-pilates-course-recognition]'),
      validity: modal.querySelector('[data-pilates-course-validity]'),
      priceMessage: modal.querySelector('[data-pilates-course-price-message]')
    };

        var courseRows = {
      participants: modal.querySelector(
        '[data-pilates-course-participants-row]'
      ),
      duration: modal.querySelector(
        '[data-pilates-course-duration-row]'
      ),
      start: modal.querySelector(
        '[data-pilates-course-start-row]'
      ),
      module1: modal.querySelector(
        '[data-pilates-course-module-row-1]'
      ),
      module2: modal.querySelector(
        '[data-pilates-course-module-row-2]'
      ),
      module3: modal.querySelector(
        '[data-pilates-course-module-row-3]'
      ),
      module4: modal.querySelector(
        '[data-pilates-course-module-row-4]'
      )
    };

    var modulesCountWrapper = modal.querySelector(
      '[data-pilates-course-modules-wrapper]'
    );

    var breakdownElement = modal.querySelector(
      '[data-pilates-booking-breakdown]'
    );

    var reformerCounterElement = modal.querySelector(
      '[data-pilates-reformer-counter]'
    );

    var towerCounterElement = modal.querySelector(
      '[data-pilates-tower-counter]'
    );

    var selected = [];
    var currentAction = '';
    var currentType = '';
    var requiredCount = 1;
    var validityUnit = 'none';
    var validityValue = 1;
    var reformerLimit = 0;
    var towerLimit = 0;
    var currentCourse = null;
    var lastTrigger = null;

    var events = parseEvents(
      (bookingData.events || []).concat(
        bookingData.privateEvents || []
      )
    );

    var firstEventDate = findFirstEventDate(events);

    var currentMonth = firstEventDate
      ? new Date(firstEventDate.getFullYear(), firstEventDate.getMonth(), 1)
      : new Date();

    function parseEvents(rawEvents) {
      return rawEvents
        .map(function (event) {
          var parts = String(event.title || '').split('|');
          var dateString = (parts[0] || '').trim();
          var timeString = (parts.slice(1).join('|') || '').trim();

          if (!/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
            return null;
          }

          var dateParts = dateString.split('-').map(Number);
          var date = new Date(
            dateParts[0],
            dateParts[1] - 1,
            dateParts[2]
          );

          return {
            id: Number(event.id),
            type: event.type,
            className: event.className,
            title: event.title,
            dateString: dateString,
            time: timeString,
            date: date,
            available: Boolean(event.available),
            inventory: Number(event.inventory || 0)
          };
        })
        .filter(Boolean)
        .sort(function (a, b) {
          return a.date - b.date || a.time.localeCompare(b.time);
        });
    }

    function findFirstEventDate(allEvents) {
      var now = startOfDay(new Date());

      var futureEvent = allEvents.find(function (event) {
        return event.date >= now && event.available;
      });

      return futureEvent ? futureEvent.date : null;
    }

    function startOfDay(date) {
      return new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate()
      );
    }

    function toDateKey(date) {
      var year = date.getFullYear();
      var month = String(date.getMonth() + 1).padStart(2, '0');
      var day = String(date.getDate()).padStart(2, '0');

      return year + '-' + month + '-' + day;
    }

    function formatDate(date) {
      return new Intl.DateTimeFormat('ro-RO', {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
      }).format(date);
    }

    function escapeHtml(value) {
      return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    }

    function getAllowedTypes(action) {
      if (action.indexOf('reformer') === 0) {
        return ['reformer'];
      }

      if (action.indexOf('tower') === 0) {
        return ['tower'];
      }

      if (action.indexOf('semi_private') === 0) {
        return ['semi_private'];
      }

      if (action.indexOf('private') === 0) {
        return ['private'];
      }

      if (
        action === 'group_package' ||
        action === 'group_single'
      ) {
        return ['reformer', 'tower'];
      }

      return [];
    }

    function getProduct(action) {
      return bookingData.products[action] || null;
    }

    function openModal(trigger) {
      lastTrigger = trigger;
      selected = [];

      currentAction = trigger.dataset.bookingAction || '';
      requiredCount = Number(trigger.dataset.bookingCount || 1);

      if (currentAction === 'course') {
        currentCourse = {
          productId: Number(trigger.dataset.courseProductId || 0),
          productTitle:
            trigger.dataset.courseProductTitle ||
            trigger.dataset.bookingTitle ||
            'Curs Pilates',
          productAvailable:
            trigger.dataset.courseProductAvailable === 'true',
          title:
            trigger.dataset.bookingTitle ||
            'Curs Pilates',
          participants:
            trigger.dataset.courseParticipants || '',
          duration:
            trigger.dataset.courseDuration || '',
          start:
            trigger.dataset.courseStart || '',
          modulesCount:
            trigger.dataset.courseModulesCount || '',
          module1:
  trigger.getAttribute('data-course-module-1') || '',
module2:
  trigger.getAttribute('data-course-module-2') || '',
module3:
  trigger.getAttribute('data-course-module-3') || '',
module4:
  trigger.getAttribute('data-course-module-4') || '',
          certification:
            trigger.dataset.courseCertification || '',
          recognition:
            trigger.dataset.courseRecognition || '',
          validity:
            trigger.dataset.courseValidity || '',
          priceMessage:
            trigger.dataset.coursePriceMessage ||
            'Preț curs: disponibil la cerere.'
        };

        titleElement.textContent = currentCourse.title;
        instructionElement.textContent =
          'Consultă detaliile cursului și rezervă un loc.';

        populateCourse();
        hideError();

        calendarArea.hidden = true;
        summaryElement.hidden = true;
        courseArea.hidden = false;
        modal.classList.add('pilates-booking--course');
        setModalVisibility(true);

        document.body.classList.add('pilates-booking-open');

        courseContinueButton.disabled =
          !currentCourse.productAvailable;

        courseContinueButton.textContent =
          currentCourse.productAvailable
            ? 'Rezervă un loc'
            : 'Locuri epuizate';

        return;
      }

      currentCourse = null;
      calendarArea.hidden = false;
      summaryElement.hidden = false;
      courseArea.hidden = true;
      modal.classList.remove('pilates-booking--course');

      validityUnit =
        trigger.dataset.validityUnit || 'none';

      validityValue = Number(
        trigger.dataset.validityValue || 1
      );

      reformerLimit = Number(
        trigger.dataset.reformerLimit || 0
      );

      towerLimit = Number(
        trigger.dataset.towerLimit || 0
      );

      if (!Number.isFinite(requiredCount) || requiredCount < 1) {
        requiredCount = 1;
      }

      var allowedTypes = getAllowedTypes(currentAction);
      currentType = allowedTypes[0] || '';

      var cardTitle =
        trigger.dataset.bookingTitle ||
        'Alege sesiunile';

      titleElement.textContent = cardTitle;

      instructionElement.textContent =
        requiredCount === 1
          ? 'Alege o dată și o oră disponibile.'
          : 'Alege exact ' +
            requiredCount +
            ' sesiuni înainte de a continua.';

      hideError();

      var filteredEvents = getFilteredEvents();
      var firstFilteredEvent =
        findFirstEventDate(filteredEvents);

      if (firstFilteredEvent) {
        currentMonth = new Date(
          firstFilteredEvent.getFullYear(),
          firstFilteredEvent.getMonth(),
          1
        );
      }

      setModalVisibility(true);
      document.body.classList.add('pilates-booking-open');

      renderCalendar();
      renderSelection();
    }

    function closeModal() {
     setModalVisibility(false);
      selected = [];
      currentCourse = null;

      modal.classList.remove('pilates-booking--course');
      document.body.classList.remove('pilates-booking-open');

      if (lastTrigger) {
        lastTrigger.focus();
      }
    }

    function setOptionalCourseField(
      fieldElement,
      rowElement,
      value
    ) {
      var normalizedValue = String(value || '').trim();

      if (fieldElement) {
        fieldElement.textContent = normalizedValue;
      }

      if (rowElement) {
        rowElement.hidden = normalizedValue === '';
      }
    }

    function setModalVisibility(isVisible) {
      modal.hidden = !isVisible;
      modal.setAttribute(
        'aria-hidden',
        isVisible ? 'false' : 'true'
      );

      if (isVisible) {
        modal.removeAttribute('inert');
      } else {
        modal.setAttribute('inert', '');
      }
    }

    function populateCourse() {
      if (!currentCourse || !courseArea) return;

      setOptionalCourseField(
        courseFields.title,
        null,
        currentCourse.title
      );

      setOptionalCourseField(
        courseFields.participants,
        courseRows.participants,
        currentCourse.participants
      );

      setOptionalCourseField(
        courseFields.duration,
        courseRows.duration,
        currentCourse.duration
      );

      setOptionalCourseField(
        courseFields.start,
        courseRows.start,
        currentCourse.start
      );

      setOptionalCourseField(
        courseFields.modulesCount,
        modulesCountWrapper,
        currentCourse.modulesCount
      );

      setOptionalCourseField(
        courseFields.module1,
        courseRows.module1,
        currentCourse.module1
      );

      setOptionalCourseField(
        courseFields.module2,
        courseRows.module2,
        currentCourse.module2
      );

      setOptionalCourseField(
        courseFields.module3,
        courseRows.module3,
        currentCourse.module3
      );

      setOptionalCourseField(
        courseFields.module4,
        courseRows.module4,
        currentCourse.module4
      );

      setOptionalCourseField(
        courseFields.certification,
        courseFields.certification,
        currentCourse.certification
      );

      setOptionalCourseField(
        courseFields.recognition,
        courseFields.recognition,
        currentCourse.recognition
      );

      setOptionalCourseField(
        courseFields.validity,
        courseFields.validity,
        currentCourse.validity
      );

      setOptionalCourseField(
        courseFields.priceMessage,
        courseFields.priceMessage,
        currentCourse.priceMessage
      );
    }

    function getFilteredEvents() {
      var allowedTypes = getAllowedTypes(currentAction);

      return events.filter(function (event) {
        return allowedTypes.indexOf(event.type) !== -1;
      });
    }

    function renderCalendar() {
      daysElement.innerHTML = '';

      monthElement.textContent =
        MONTHS_RO[currentMonth.getMonth()] +
        ' ' +
        currentMonth.getFullYear();

      var year = currentMonth.getFullYear();
      var month = currentMonth.getMonth();

      var firstDay = new Date(year, month, 1);
      var lastDay = new Date(year, month + 1, 0);

      var mondayOffset =
        (firstDay.getDay() + 6) % 7;

      var totalVisibleCells = Math.ceil(
        (mondayOffset + lastDay.getDate()) / 7
      ) * 7;

      var gridStart = new Date(
        year,
        month,
        1 - mondayOffset
      );

      var today = startOfDay(new Date());
      var filteredEvents = getFilteredEvents();
      var hasVisibleEvents = false;

      for (
        var index = 0;
        index < totalVisibleCells;
        index++
      ) {
        var cellDate = new Date(
          gridStart.getFullYear(),
          gridStart.getMonth(),
          gridStart.getDate() + index
        );

        var dateKey = toDateKey(cellDate);

        var dayEvents = filteredEvents.filter(
          function (event) {
            return event.dateString === dateKey;
          }
        );

        if (dayEvents.length) {
          hasVisibleEvents = true;
        }

        var day = document.createElement('div');
        day.className = 'pilates-booking__day';

        if (!dayEvents.length) {
          day.classList.add(
            'pilates-booking__day--empty'
          );
        }

        if (cellDate.getMonth() !== month) {
          day.classList.add(
            'pilates-booking__day--outside'
          );
        }

        if (cellDate < today) {
          day.classList.add(
            'pilates-booking__day--past'
          );
        }

        if (
          toDateKey(cellDate) === toDateKey(today)
        ) {
          day.classList.add(
            'pilates-booking__day--today'
          );
        }

        var number = document.createElement('span');

        number.className =
          'pilates-booking__day-number';

        number.textContent =
          cellDate.getDate();

        var eventList =
          document.createElement('div');

        eventList.className =
          'pilates-booking__events';

        dayEvents.forEach(function (event) {
          eventList.appendChild(
            createEventButton(event, today)
          );
        });

        day.appendChild(number);
        day.appendChild(eventList);
        daysElement.appendChild(day);
      }

      emptyElement.hidden = hasVisibleEvents;
    }

    function createEventButton(event, today) {
      var isSelected = selected.some(
        function (item) {
          return item.id === event.id;
        }
      );

      var isPast = event.date < today;

      var isSoldOut =
        !event.available ||
        event.inventory <= 0;

      var button =
        document.createElement('button');

      button.type = 'button';

      button.className =
        'pilates-booking__event ' +
        'pilates-booking__event--' +
        event.type;

      if (isSelected) {
        button.classList.add(
          'pilates-booking__event--selected'
        );
      }

      button.disabled = isPast || isSoldOut;
      button.dataset.eventId = String(event.id);

      var availabilityText;

      if (isSoldOut) {
        availabilityText = 'Complet';
      } else if (event.inventory === 1) {
        availabilityText = 'Ultimul loc';
      } else {
        availabilityText =
          event.inventory + ' locuri';
      }

      if (isSoldOut) {
  button.classList.add(
    'pilates-booking__event--sold-out'
  );
} else if (event.inventory === 1) {
  button.classList.add(
    'pilates-booking__event--last-place'
  );
} else {
  button.classList.add(
    'pilates-booking__event--available'
  );
}

      button.innerHTML =
        '<span class="pilates-booking__event-time">' +
        escapeHtml(event.time) +
        '</span>' +
        '<span class="pilates-booking__event-name">' +
        escapeHtml(event.className) +
        '</span>' +
        '<span class="pilates-booking__event-availability">' +
        escapeHtml(availabilityText) +
        '</span>';

      button.addEventListener('click', function () {
        toggleEvent(event);
      });

      return button;
    }

    function addValidityToDate(date) {
      var result = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate()
      );

      if (validityUnit === 'days') {
        result.setDate(
          result.getDate() + validityValue
        );
      }

      if (validityUnit === 'weeks') {
        result.setDate(
          result.getDate() + validityValue * 7
        );
      }

      if (validityUnit === 'months') {
        var originalDay = result.getDate();

        result.setDate(1);

        result.setMonth(
          result.getMonth() + validityValue
        );

        var lastDayOfTargetMonth = new Date(
          result.getFullYear(),
          result.getMonth() + 1,
          0
        ).getDate();

        result.setDate(
          Math.min(
            originalDay,
            lastDayOfTargetMonth
          )
        );
      }

      return result;
    }

    function selectionFitsValidity(candidateEvents) {
      if (
        validityUnit === 'none' ||
        candidateEvents.length < 2
      ) {
        return true;
      }

      var sortedDates = candidateEvents
        .map(function (item) {
          return item.date;
        })
        .sort(function (a, b) {
          return a - b;
        });
              var firstDate = sortedDates[0];
      var lastDate = sortedDates[sortedDates.length - 1];
      var maximumDate = addValidityToDate(firstDate);

      return lastDate <= maximumDate;
    }

    function countSelectedType(type) {
      return selected.filter(function (item) {
        return item.type === type;
      }).length;
    }

    function typeLimitReached(event) {
      if (
        event.type === 'reformer' &&
        reformerLimit > 0
      ) {
        return (
          countSelectedType('reformer') >= reformerLimit
        );
      }

      if (
        event.type === 'tower' &&
        towerLimit > 0
      ) {
        return (
          countSelectedType('tower') >= towerLimit
        );
      }

      return false;
    }

    function toggleEvent(event) {
      hideError();

      var existingIndex = selected.findIndex(
        function (item) {
          return item.id === event.id;
        }
      );

      if (existingIndex !== -1) {
        selected.splice(existingIndex, 1);

        renderCalendar();
        renderSelection();
        return;
      }

      if (selected.length >= requiredCount) {
        showError(
          'Ai selectat deja toate cele ' +
            requiredCount +
            ' sesiuni. Elimină una pentru a alege alta.'
        );
        return;
      }

      if (typeLimitReached(event)) {
        var typeLabel =
          event.type === 'reformer'
            ? 'Reformer'
            : 'Tower + Chair';

        var typeLimit =
          event.type === 'reformer'
            ? reformerLimit
            : towerLimit;

        showError(
          'Poți selecta maximum ' +
            typeLimit +
            ' sesiuni ' +
            typeLabel +
            '.'
        );
        return;
      }

      var candidateSelection =
        selected.concat([event]);

      if (!selectionFitsValidity(candidateSelection)) {
        var validityMessage = '';

        if (validityUnit === 'weeks') {
          validityMessage =
            validityValue +
            (validityValue === 1
              ? ' săptămână'
              : ' săptămâni');
        }

        if (validityUnit === 'months') {
          validityMessage =
            validityValue === 1
              ? 'o lună'
              : validityValue + ' luni';
        }

        if (validityUnit === 'days') {
          validityMessage =
            validityValue + ' zile';
        }

        showError(
          'Toate sesiunile trebuie să fie în intervalul de ' +
            validityMessage +
            ' calculat de la prima ședință.'
        );
        return;
      }

      selected.push(event);

      selected.sort(function (a, b) {
        return (
          a.date - b.date ||
          a.time.localeCompare(b.time)
        );
      });

      renderCalendar();
      renderSelection();
    }

    function renderSelection() {
      selectionElement.innerHTML = '';

      counterElement.textContent =
        selected.length + ' / ' + requiredCount;

      var reformerCount =
        countSelectedType('reformer');

      var towerCount =
        countSelectedType('tower');

      var isGroupBooking =
        currentAction === 'group_package';

      breakdownElement.hidden = !isGroupBooking;

      if (isGroupBooking) {
        reformerCounterElement.textContent =
          reformerCount + ' / ' + reformerLimit;

        towerCounterElement.textContent =
          towerCount + ' / ' + towerLimit;
      }

      var remaining =
        requiredCount - selected.length;

      if (selected.length === 0) {
        selectionElement.innerHTML =
          '<p class="pilates-booking__selection-empty">' +
          'Sesiunile alese vor apărea aici.' +
          '</p>';
      } else {
        selected.forEach(function (event) {
          var item =
            document.createElement('div');

          item.className =
            'pilates-booking__selected-item';

          item.innerHTML =
            '<div class="pilates-booking__selected-info">' +
              '<strong>' +
                escapeHtml(event.className) +
              '</strong>' +
              '<span>' +
                escapeHtml(formatDate(event.date)) +
                ' · ' +
                escapeHtml(event.time) +
              '</span>' +
            '</div>' +
            '<button type="button" class="pilates-booking__remove" aria-label="Elimină sesiunea">×</button>';

          item
            .querySelector(
              '.pilates-booking__remove'
            )
            .addEventListener(
              'click',
              function () {
                selected = selected.filter(
                  function (selectedEvent) {
                    return (
                      selectedEvent.id !== event.id
                    );
                  }
                );

                renderCalendar();
                renderSelection();
              }
            );

          selectionElement.appendChild(item);
        });
      }

      if (remaining > 1) {
        remainingElement.textContent =
          'Mai selectează ' +
          remaining +
          ' sesiuni.';
      } else if (remaining === 1) {
        remainingElement.textContent =
          'Mai selectează o sesiune.';
      } else {
        remainingElement.textContent =
          'Selecția este completă.';
      }

      var respectsTypeLimits = true;

      if (currentAction === 'group_package') {
        respectsTypeLimits =
          countSelectedType('reformer') ===
            reformerLimit &&
          countSelectedType('tower') ===
            towerLimit;
      }

      continueButton.disabled =
        selected.length !== requiredCount ||
        !respectsTypeLimits;

      if (selected.length === requiredCount) {
        continueButton.textContent =
          requiredCount === 1
            ? 'Continuă cu rezervarea'
            : 'Continuă cu cele ' +
              requiredCount +
              ' sesiuni';
      } else {
        continueButton.textContent =
          requiredCount === 1
            ? 'Selectează sesiunea'
            : 'Selectează ' +
              requiredCount +
              ' sesiuni';
      }
    }

    function createBookingReference() {
      return (
        'PB-' +
        Date.now().toString(36).toUpperCase() +
        '-' +
        Math.random()
          .toString(36)
          .slice(2, 7)
          .toUpperCase()
      );
    }

    function addBookingToCart() {
      var isCourse =
        currentAction === 'course';

      if (
        !isCourse &&
        selected.length !== requiredCount
      ) {
        return;
      }

      var commercialProduct =
        isCourse && currentCourse
          ? {
              id: currentCourse.productId,
              title: currentCourse.productTitle
            }
          : getProduct(currentAction);

      if (
        !commercialProduct ||
        !commercialProduct.id ||
        Number(commercialProduct.id) === 0
      ) {
        showError(
          'Produsul comercial nu este configurat pentru acest card.'
        );
        return;
      }

      hideError();

      var activeButton = isCourse
        ? courseContinueButton
        : continueButton;

      activeButton.classList.add('is-loading');
      activeButton.disabled = true;
      activeButton.textContent =
        'Se adaugă în coș…';

      var bookingReference =
        createBookingReference();

      var sessionSummary = selected
        .map(function (event) {
          return (
            formatDate(event.date) +
            ', ' +
            event.time +
            ' — ' +
            event.className
          );
        })
        .join(' | ');

      var commercialProperties;

      if (isCourse) {
        commercialProperties = {
          'Curs': currentCourse.title,
          'Start curs': currentCourse.start,
          'Durată': currentCourse.duration,
          'Modul 1': currentCourse.module1,
          'Modul 2': currentCourse.module2,
          'Modul 3': currentCourse.module3,
          'Modul 4': currentCourse.module4,
          'Preț curs': 'Disponibil la cerere',
          '_booking_reference':
            bookingReference,
          '_booking_role': 'commercial',
          '_booking_type': 'course',
          '_booking_action': 'course'
        };
      } else {
        commercialProperties = {
          'Sesiuni rezervate':
            sessionSummary,
          '_booking_reference':
            bookingReference,
          '_booking_role': 'commercial',
          '_booking_type': 'class',
          '_booking_action': currentAction,
          '_booking_session_count':
            String(selected.length)
        };
      }

      var items = [
        {
          id: Number(commercialProduct.id),
          quantity: 1,
          properties: commercialProperties
        }
      ];

      if (!isCourse) {
        selected.forEach(function (event) {
          items.push({
            id: event.id,
            quantity: 1,
            properties: {
              'Clasă': event.className,
              'Data': formatDate(event.date),
              'Ora': event.time,
              '_booking_reference':
                bookingReference,
              '_booking_role': 'slot',
              '_booking_type': 'class',
              '_booking_action':
                currentAction,
              '_booking_parent_variant':
                String(commercialProduct.id)
            }
          });
        });
      }

      var root =
        window.Shopify &&
        window.Shopify.routes
          ? window.Shopify.routes.root
          : '/';

      var cartSectionIds = Array.from(
        document.querySelectorAll(
          'cart-items-component[data-section-id]'
        )
      )
        .map(function (component) {
          return component.dataset.sectionId;
        })
        .filter(
          function (
            sectionId,
            index,
            allIds
          ) {
            return (
              sectionId &&
              allIds.indexOf(sectionId) === index
            );
          }
        );

      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type':
            'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: items,
          sections: cartSectionIds.join(','),
          sections_url:
            window.location.pathname
        })
      })
        .then(function (response) {
          return response
            .json()
            .then(function (data) {
              if (!response.ok) {
                throw new Error(
                  data.description ||
                    data.message ||
                    'Rezervarea nu a putut fi adăugată.'
                );
              }

              return data;
            });
        })
        .then(function (response) {
          closeModal();
          openCartDrawer(response);
        })
        .catch(function (error) {
          showError(
            error.message ||
              'Unele locuri nu mai sunt disponibile. Reîncarcă pagina și încearcă din nou.'
          );

          activeButton.classList.remove(
            'is-loading'
          );

          activeButton.disabled = false;

          activeButton.textContent = isCourse
            ? 'Rezervă un loc'
            : requiredCount === 1
              ? 'Continuă cu rezervarea'
              : 'Continuă cu cele ' +
                requiredCount +
                ' sesiuni';
        });
    }

    function openCartDrawer(response) {
      var cartDrawer =
        document.querySelector(
          'cart-drawer-component'
        );

      var root =
        window.Shopify &&
        window.Shopify.routes
          ? window.Shopify.routes.root
          : '/';

      fetch(root + 'cart.js', {
        headers: {
          Accept: 'application/json'
        }
      })
        .then(function (cartResponse) {
          if (!cartResponse.ok) {
            throw new Error(
              'Coșul nu a putut fi actualizat.'
            );
          }

          return cartResponse.json();
        })
        .then(function (cart) {
          document.dispatchEvent(
            new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                data: {
                  sections:
                    response.sections || {},
                  itemCount: cart.item_count,
                  source:
                    'pilates-booking-calendar'
                },
                resource: cart
              }
            })
          );

          if (
            cartDrawer &&
            typeof cartDrawer.open ===
              'function'
          ) {
            requestAnimationFrame(
              function () {
                cartDrawer.open();
              }
            );

            return;
          }

          window.location.href =
            root + 'cart';
        })
        .catch(function (error) {
          console.error(error);

          window.location.href =
            root + 'cart';
        });
    }

    function showError(message) {
      errorElement.textContent = message;
      courseErrorElement.textContent =
        message;

      errorElement.hidden =
        currentAction === 'course';

      courseErrorElement.hidden =
        currentAction !== 'course';
    }

    function hideError() {
      errorElement.textContent = '';
      courseErrorElement.textContent = '';
      errorElement.hidden = true;
      courseErrorElement.hidden = true;
    }

    modal
      .querySelector(
        '[data-pilates-booking-previous]'
      )
      .addEventListener(
        'click',
        function () {
          currentMonth = new Date(
            currentMonth.getFullYear(),
            currentMonth.getMonth() - 1,
            1
          );

          renderCalendar();
        }
      );

    modal
      .querySelector(
        '[data-pilates-booking-next]'
      )
      .addEventListener(
        'click',
        function () {
          currentMonth = new Date(
            currentMonth.getFullYear(),
            currentMonth.getMonth() + 1,
            1
          );

          renderCalendar();
        }
      );

    continueButton.addEventListener(
      'click',
      addBookingToCart
    );

    courseContinueButton.addEventListener(
      'click',
      addBookingToCart
    );

    document.addEventListener(
      'click',
      function (event) {
        var trigger = event.target.closest(
          '.pilates-booking-trigger'
        );

        if (trigger) {
          event.preventDefault();
          openModal(trigger);
          return;
        }

        if (
          event.target.closest(
            '[data-pilates-booking-close]'
          )
        ) {
          closeModal();
        }
      }
    );

    document.addEventListener(
      'keydown',
      function (event) {
        if (
          event.key === 'Escape' &&
          !modal.hidden
        ) {
          closeModal();
        }
      }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializePilatesBooking
    );
  } else {
    initializePilatesBooking();
  }

  document.addEventListener(
    'shopify:section:load',
    initializePilatesBooking
  );
})();